import { client } from "../utils/api-client";
import { ClientConfigSchema } from "../interfaces/apiClient.interface";

function useClient<T>() {
  return (endpoint: string, config?: ClientConfigSchema) => client<T>(endpoint, { ...config });
}

export { useClient };
